import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Checkbox, FormControlLabel, Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Logo from '../Components/Logo';
import { useTheme } from "@mui/material/styles";
import { useDispatch } from 'react-redux';
import { contact } from '../Redux/Contact/contactaction';
import Toastify from '../Components/Toastify';

const Contact = () => {
    const { t } = useTranslation(); // Use translation hook
    const theme = useTheme();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

    // Form validation schema using Yup
    const validationSchema = Yup.object({
        nome: Yup.string().required(t('contact.required')),
        cognome: Yup.string().required(t('contact.required')),
        azienda: Yup.string().required(t('contact.required')),
        email: Yup.string().email(t('contact.invalidEmail')).required(t('contact.required')),
        telefono: Yup.string().required(t('contact.required')),
        privacy: Yup.boolean().oneOf([true], t('contact.acceptPrivacy')),
    });
    useEffect(() => {
        window.scroll(0, 0)
    }, [])


    const formik = useFormik({
        initialValues: {
            nome: '',
            cognome: '',
            azienda: '',
            email: '',
            telefono: '',
            note: '',
            privacy: false,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // Handle form submission (e.g., send data to server)
            console.log(values);
            dispatch(contact(values))
        },
    });

    return (
        <Box sx={{ mt: 3.7,mb:5 }}>
            <Logo />
            <Box elevation={3} sx={{ padding: 4, borderRadius: '16px', textAlign: 'center' }}>
                {/* Title and description */}
                <Box sx={{ mb: 6,mt:5, display: 'flex', flexDirection: "column", alignItems: 'center' }}>
                    <Typography  gutterBottom sx={{ fontWeight: 500,lineHeight:{xs:1,md:0},fontSize:{xs:"24px",md:"36px" }}}>
                        {t('contact.formTitle')}
                    </Typography>
                    <Typography  gutterBottom sx={{ mb: 2, fontWeight: 500,fontSize:{xs:"24px",md:"36px" }  }}>
                        {t('contact.formDesc')}
                    </Typography>
                </Box>
                <Toastify/>

                <Box sx={{ display: 'flex', justifyContent: "center" }}>
                    <form onSubmit={formik.handleSubmit} style={{ width: isMobile?"100%":'85%' }}>
                        <Grid container columnGap={6} spacing={3} sx={{ display: "flex", justifyContent: "center" }}>
                            {/* First Name */}
                            <Grid item xs={12} sm={5.5} md={3.8}>
                                {isMobile && <label style={Style.label}>{t('contact.nome')}<span style={Style.req}>*</span></label>}
                                <TextField
                                    fullWidth
                                    id="nome"
                                    name="nome"
                                    value={formik.values.nome}
                                    onChange={formik.handleChange}
                                    error={formik.touched.nome && Boolean(formik.errors.nome)}
                                    helperText={formik.touched.nome && formik.errors.nome}
                                    sx={Style.input} />
                                {!isMobile && <label style={Style.label}>{t('contact.nome')}<span style={Style.req}>*</span></label>}
                            </Grid>

                            {/* Last Name */}
                            <Grid item xs={12} sm={5.5}  md={3.8}>
                                {isMobile && <label style={Style.label}>{t('contact.cognome')}<span style={Style.req}>*</span></label>}
                                <TextField
                                    fullWidth
                                    id="cognome"
                                    name="cognome"
                                    value={formik.values.cognome}
                                    onChange={formik.handleChange}
                                    error={formik.touched.cognome && Boolean(formik.errors.cognome)}
                                    helperText={formik.touched.cognome && formik.errors.cognome}
                                    sx={Style.input} />
                                {!isMobile && <label style={Style.label}>{t('contact.cognome')}<span style={Style.req}>*</span></label>}
                            </Grid>

                            {/* Company */}
                            <Grid item xs={12} md={8}>
                                <label style={Style.label}>{t('contact.azienda')}<span style={Style.req}>*</span></label>
                                <TextField
                                    fullWidth
                                    id="azienda"
                                    name="azienda"
                                    value={formik.values.azienda}
                                    onChange={formik.handleChange}
                                    error={formik.touched.azienda && Boolean(formik.errors.azienda)}
                                    helperText={formik.touched.azienda && formik.errors.azienda}
                                    sx={Style.input}
                                />
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12} md={8}>
                                <label style={Style.label}>{t('contact.email')}<span style={Style.req}>*</span></label>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    sx={Style.input}
                                />
                            </Grid>

                            {/* Phone */}
                            <Grid item xs={12} md={8}>
                                <label style={Style.label}>{t('contact.telefono')}<span style={Style.req}>*</span></label>
                                <TextField
                                    fullWidth
                                    id="telefono"
                                    name="telefono"
                                    value={formik.values.telefono}
                                    onChange={formik.handleChange}
                                    error={formik.touched.telefono && Boolean(formik.errors.telefono)}
                                    helperText={formik.touched.telefono && formik.errors.telefono}
                                    sx={Style.input}

                                />
                            </Grid>

                            {/* Notes */}
                            <Grid item xs={12} md={8}>
                                <label style={{fontWeight:400,marginBottom:'5px',fontSize:"18px"}}>{t('contact.note')}</label>
                                <TextField
                                    fullWidth
                                    id="note"
                                    name="note"
                                    value={formik.values.note}
                                    onChange={formik.handleChange}
                                    multiline
                                    rows={4}
                                    sx={Style.input}
                                />
                            </Grid>

                            {/* Privacy */}
                            <Grid item xs={12}>
                                <p style={{...Style.label,margin:0}}>Privacy <span style={Style.req}>*</span></p>
                                <FormControlLabel
                                    sx={{ ml: 1 }}
                                    control={
                                        <Checkbox
                                            id="privacy"
                                            name="privacy"
                                            color="primary"
                                            checked={formik.values.privacy}
                                            onChange={formik.handleChange}
                                            error={formik.touched.privacy && Boolean(formik.errors.privacy)}
                                        />
                                    }
                                />
                                <Box sx={{
                                    display: "flex",
                                    alignItems: 'center',
                                    flexDirection: "column"
                                }}>
                                    <p style={{fontWeight:400,fontFamily:'"roc-grotesk", sans-serif',fontSize:"18px" ,margin:0  }}>{t('contact.agree')}</p>
                                    <p style={{ width: !isMobile && '50%', textAlign: 'center',fontFamily:'"roc-grotesk", sans-serif' ,fontWeight:300,margin:0 }}>{t('contact.auth')}</p>
                                </Box>
                                {formik.touched.privacy && formik.errors.privacy ? (
                                    <Typography variant="body2" color="error">
                                        {formik.errors.privacy}
                                    </Typography>
                                ) : null}
                            </Grid>

                            {/* Submit Button */}
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        background: 'linear-gradient(to right, rgb(53, 66, 255) 0%,#B87DFF, rgb(85, 247, 255) 100%)',
                                        color: '#fff',
                                        padding: '12px',
                                        borderRadius: '30px',
                                        boxShadow: "none",
                                        fontWeight: 600,
                                        fontFamily:'"roc-grotesk", sans-serif' ,
                                        mt: 2,
                                        fontSize: '18px',
                                        width: { xs: "50%", md: '30%' },
                                        "&:hover": {
                                            boxShadow: "none"
                                        }
                                    }}
                                >
                                    {t('contact.submit')}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Box>
        </Box>
    );
};

export default Contact;
const Style = {
    input: {
        border: "none",
        borderRadius: "20px !important",
        "& .MuiInputBase-root": {
            background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #2A38FF 0%, #2A38FF 100%) border-box",
            border: '1px solid #2A38FF',
            borderRadius: "20px !important",
            borderColor: " #02010100",
        },
        "&.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input:-webkit-autofill": {
            p: { xs: "10px 10px" }
        },
        "& .MuiFormHelperText-root": {
            // Style the root element of MuiFormHelperText
            margin: 0,
            marginTop: 0,
            color: "red",
        },
        "&.MuiTextField-root": {
            "& fieldset": {
                border: '1px solid red',
            }
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderRadius: "20px",
                borderColor: "transparent", // Removes the border
            },
            "&:hover fieldset": {
                borderColor: "transparent", // Removes the border on hover
            },
            "&.Mui-focused fieldset": {
                borderRadius: "20px",
                borderColor: "transparent", // Removes the border when focused
            },
        },
    },
    label: { fontSize:"20px", fontWeight: 600 ,fontFamily:'"roc-grotesk", sans-serif' },
    req: { color: '#FF0000',fontFamily:'"roc-grotesk", sans-serif'  }
}
